module.exports = __webpack_public_path__ + "static/models/horse.883fd33.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/models/runner/horse.json
// module id = 592
// module chunks = 1